import { kebabCase, includes } from 'lodash';

export const STREAMING_ROOT_PATH = ['my-plan', 'workouts', 'series', 'trainers'];

export const isAccountPage = (path: string) => {
    return /^\/account/.test(path);
};

export const isStreamingPage = (path: string) => {
    const rootPath = path.split('/')[1];

    return includes(STREAMING_ROOT_PATH, rootPath);
};

export const navLink = (name: string) => `/${kebabCase(name)}`;

export const stripTrailingSlash = (url: string) => url.replace(/\/$/g, '');
